import { jsx } from 'react/jsx-runtime';
import { Modal as Modal$1 } from '@ubnt/ui-components/Modal';
import { useCallback } from 'react';
import { InnerWrap } from './Modal.styles.mjs';
"use strict";
const Modal = function Modal2({
  overlayClassName,
  children,
  lockScroll,
  ...rest
}) {
  if (!overlayClassName) {
    overlayClassName = "react-modal-portal-overlay";
  }
  const handleAfterOpen = useCallback(() => {
    if (lockScroll) {
      document.body.style.overflow = "hidden";
    }
    rest.onAfterOpen?.();
  }, [lockScroll, rest]);
  const handleAfterClose = useCallback(() => {
    if (lockScroll) {
      document.body.style.overflow = "unset";
    }
    rest.onAfterClose?.();
  }, [lockScroll, rest]);
  return /* @__PURE__ */jsx(Modal$1, {
    ...rest,
    overlayClassName,
    onAfterOpen: handleAfterOpen,
    onAfterClose: handleAfterClose,
    children: /* @__PURE__ */jsx(InnerWrap, {
      children
    })
  });
};
export { Modal };
//# sourceMappingURL=Modal.mjs.map
